import ACTIONS from ".";
import axios from "../../utils/axios";

export const getProspects = () => async (dispatch) => {
  try {
    // const res = await axios.get("/api/emails/all_prospects");
    const res = await axios.get(
      "/api/emails/prospect_pagination?pageIndex=1&pageSize=50"
    );
    dispatch({
      type: ACTIONS.GET_PROSPECTS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
  }
};

export const getPagination =
  (pageIndex, pageSize, search, isViewed) => async (dispatch) => {
    try {
      // const res = await axios.get("/api/emails/all_prospects");
      // console.log(pageIndex, pageSize);
      const res = await axios.get(
        `/api/emails/prospect_pagination?pageIndex=${pageIndex}&pageSize=${pageSize}&search=${search}&isRead=${isViewed}`
      );
      dispatch({
        type: ACTIONS.GET_PROSPECTS,
        payload: res.data,
      });
    } catch (error) {
      console.log(error);
    }
  };
